// import { useNavigate } from 'react-router-dom';

import ModalApproveAction from './ModalApproveAction';

export default ModalApproveAction;

// function ExampleComponent() {
//   const navigate = useNavigate();
//   const handleClick = () => {
//     // переходим на страницу / users / 123 и передаем данные в объект  location.state

//     navigate('/users/123', { state: { name: 'John', age: 30 } });
//   };
//   return <button onClick={handleClick}>Go to User 123</button>;
// }
